import React from "react";
import { CausesFields } from "../Utils/data";
import { Link } from "react-router-dom";

const Causes = () => {
  return (
    <div>
      <div className="flex flex-col gap-4 text-Orange text-center font-edu-sa text-base font-semibold uppercase">
        <p>Our Works</p>
        <h2 className="text-2xl md:text-4xl font-edu-sa text-center font-bold text-ndlogoBlue">
          {" "}
          Popular Causes
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 md:p-10">
        {CausesFields.map((item, index) => (
          <div
            key={index}
            className="flex flex-col rounded-t-3xl shadow-md scale-100 hover:scale-105 transition-transform duration-300"
          >
            <div className="rounded-t-3xl h-40 overflow-hidden">
              <img
                src={item.img}
                alt="Causes Img"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4 bg-white">
              <h3 className="text-base md:text-xl font-serif font-bold text-ndlogoBlue mb-2">
                {item.title}
              </h3>
              <p className="text-mediumGray leading-relaxed text-sm md:text-base">
                Lorem ipsum dolor amet consectetur adipisicing dolor magna
                aliqua elit sed eiusmod tempor incididunt labore dolor magna
                aliqua enim ad minimveniam quis nostrud exercita.
              </p>
              <Link to={item.link}>
                <button className="mt-3 md:mt-6 px-3 md:px-6 py-3 bg-white text-Orange text-sm md:text-base font-semibold rounded-full shadow-lg hover:bg-Orange hover:text-white transition-all duration-300">
                  Read More
                </button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Causes;
